export default "//cdn.scentbird.com/assets/frontbird-site/images/flower-shop_ddf567.jpg";